import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Check if we're in a widget route (Link / Add to Page deployment modes)
const isWidgetRoute = typeof window !== 'undefined' && window.location.pathname.startsWith('/widget');

// Check if this is the Chat Button widget bundle (web component build)
// process.env.BUILD_TARGET is replaced at build time by Vite's define config
const isWidgetBundle = process.env.BUILD_TARGET === 'webcomponent';

const isWidget = isWidgetRoute || isWidgetBundle;

// For the Chat Button widget, translation files must be loaded from the
// GPT-trainer server domain, since window.location points to the embedding website.
// The correct domain is available via window.GPTTConfig.domain, which is set by
// the embedding script before the widget bundle loads.
const getBackendOptions = (): Record<string, string> => {
    if (isWidgetBundle && typeof window !== 'undefined') {
        const domain = window.GPTTConfig?.domain || 'app.gpt-trainer.com';
        return {
            loadPath: `https://${domain}/locales/{{lng}}/{{ns}}.json`,
        };
    }
    return {};
};

i18n
    // load translation using http -> see /public/locales
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languagedetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: 'en',
        debug: process.env.NODE_ENV === 'development',
        ns: isWidget
            ? ['widget']
            : ['common', 'widget', 'auth', 'agents', 'chatbot', 'sources', 'integrations', 'subscription', 'onboarding', 'collaborators', 'voice', 'customization'],
        defaultNS: isWidget ? 'widget' : 'common',
        backend: getBackendOptions(),

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });

export default i18n;
